import posthog from "posthog-js";
import { axiosBasic, getUserInfo } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { actionTypes } from "./designationActionTypes";
import { UPDATE_PAGING } from "../../common/pagination/paginationActionTypes";
import { Common } from "../../../utils";

const { Designation } = config.REST_API;

const getAll = (items) => ({ type: actionTypes.DG_SHOW_LIST, payload: items });
const softDelete = (item) => ({ type: actionTypes.DG_DELETE_SOFT, payload: item });

export const DesignationListing = (options, currentPage) => {
  const take = options.take ?? options.limit ?? 20;
  const newUrl =
    Designation.Get +
    options.start +
    "/" +
    options.page +
    "/" +
    take;
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { start: options.start, page: options.page, take, currentPage };
    dispatch({ type: actionTypes.DG_LOADING_START });
    axiosBasic
      .get(newUrl)
      .then((response) => {
        const baseModel = response.data;
        const success = baseModel.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("DesignationListing", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : baseModel.message,
          });
        }
        if (success) {
          dispatch({
            type: UPDATE_PAGING,
            payload: { data: { total: baseModel.total, currentPage } },
          });
          dispatch(getAll(baseModel.data));
        } else {
          Common.showErrorMessage(baseModel.message);
        }
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("DesignationListing", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        Common.showErrorMessage("Something went wrong");
        console.log(error);
      });
  };
};

export const saveDesignation = (model) => {
  const obj = {
    Name: model.name.trim(),
    Notes: (model.notes || "").trim(),
  };
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { hasName: !!(model?.name?.trim()), hasNotes: !!(model?.notes?.trim()) };
    dispatch({ type: actionTypes.DG_LOADING_START });
    return axiosBasic
      .post(Designation.Create, obj)
      .then((response) => {
        const res = response.data;
        const success = res.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("saveDesignation", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : res.message,
          });
        }
        if (success) {
          dispatch({ type: actionTypes.DG_ADD_SUCCESS, payload: res.data });
        }
        dispatch({ type: actionTypes.DG_LOADING_STOP });
        return res;
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("saveDesignation", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.DG_LOADING_STOP });
        return error;
      });
  };
};

const toPatchBody = (item) => ({
  Id: item.id ?? item.Id,
  Name: item.name ?? item.Name,
  Notes: item.notes ?? item.Notes ?? "",
  IsActive: item.isActive !== undefined ? item.isActive : item.IsActive !== false,
});

export const patchDesignation = (item) => {
  const obj = toPatchBody(item);
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { id: obj.Id, hasName: !!obj.Name, hasNotes: !!obj.Notes };
    dispatch({ type: actionTypes.DG_LOADING_START });
    return axiosBasic
      .patch(Designation.Patch, obj)
      .then((response) => {
        const res = response.data;
        const success = res.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("patchDesignation", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : res.message,
          });
        }
        if (success) {
          dispatch({ type: actionTypes.DG_UPDATE_SUCCESS, payload: res.data });
        }
        dispatch({ type: actionTypes.DG_LOADING_STOP });
        return res;
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("patchDesignation", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.DG_LOADING_STOP });
        return error;
      });
  };
};

export const deleteDesignation = (item) => {
  const id = item.id ?? item.Id;
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { id };
    dispatch({ type: actionTypes.DG_LOADING_START });
    // designations: DELETE .../Designation/SoftDelete?id={id} (endPoints Delete ends with ?id=)
    return axiosBasic
      .delete(`${Designation.Delete}${encodeURIComponent(id ?? "")}`, {
        transformRequest: [
          (data, headers) => {
            delete headers["Content-Type"];
            return data;
          },
        ],
      })
      .then((response) => {
        dispatch({ type: actionTypes.DG_LOADING_STOP });
        const baseModel = response.data;
        const success = baseModel.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("deleteDesignation", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : baseModel.message,
          });
        }
        if (success) {
          const list = baseModel.data ?? baseModel.Data;
          if (Array.isArray(list)) {
            dispatch(getAll(list));
          } else {
            dispatch(softDelete(item));
          }
        }
        const msg =
          typeof baseModel.message === "string"
            ? baseModel.message
            : baseModel.message?.message ?? baseModel.message?.Message;
        return { success: !!success, message: msg };
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("deleteDesignation", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.DG_LOADING_STOP });
        throw error;
      });
  };
};
